import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { type FC } from 'react';

/** Shared search field for My updates by status and Audit table regulatory watch views. */
export const UpdatesSearchField: FC<{
  value: string;
  onChange: (value: string) => void;
}> = ({ value, onChange }) => (
  <div className="relative w-[280px] shrink-0">
    <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-500" />
    <Input
      placeholder="Search updates"
      value={value}
      onChange={e => onChange(e.target.value)}
      className="pl-9"
    />
  </div>
);
